module.exports = __webpack_public_path__ + "static/media/gradient only.d77a3c3e.png";